
export type GetUserProfile404 = {
  error?: string;
  message?: string;
  timestamp?: string;
};
